import { CustomerConfirmController } from './customerConfirm.controller';
import template from './customerConfirm.html';
// // import './customerConfirm.scss';

export const customerConfirmComponent = {
  name: 'customerConfirmComponent',
  restrict: 'E',
  template,
  controller: CustomerConfirmController,
  controllerAs: 'vm',
  bindings: {
    isProtected: '<'
  }
};
